
import { FORM_TYPES } from 'components/shared/generatedForm/GeneratedForm';

export const MarketplaceOrderFields = [
  {
    props: {
      name: "bistroMenuId",
      id: "bistroMenuId",
      label: "Marketplace",
    },
    size: 4,
    type: FORM_TYPES.SelectAPI,
    endpoint: "getMarketplaceByFacilitySelect",
  },
  {
    props: {
      name: "startDate",
      id: "startDate",
      label: "Start Date",
      disableFuture: true
    },
    size: 3,
    type: FORM_TYPES.DatePicker,
  },
  {
    props: {
      name: "endDate",
      id: "endDate",
      label: "End Date",
      disableFuture: true
    },
    size: 3,
    type: FORM_TYPES.DatePicker,
  },
];